import type { JSX } from 'react';
import { DefaultGlowRing } from './DefaultGlowRing.js';
import type { ChargingAnimationProps } from '../../dispatchers/ChargingAnimation.js';

/**
 * Default theme's charging animation. Renders DefaultGlowRing — the
 * premium battery-liquid-fill visual (outer halo + rising liquid +
 * animated arc + dual readout) that ChargingPage historically
 * consumed directly. Moving it through the dispatcher preserves the
 * existing visual while letting skins that compose over Default
 * reuse the same base and layer their own overlays.
 */
export function DefaultAnimation(props: ChargingAnimationProps): JSX.Element {
  return (
    <DefaultGlowRing
      percent={props.percent}
      label={props.active ? 'CHARGING' : 'BATTERY'}
      active={props.active ?? false}
      size={props.size ?? 220}
      tone="charging"
    />
  );
}
